import { FC } from "react";
import { Trans } from "react-i18next";

import { PhoneLinkTestWrapper } from "./controls.panels.styled";

interface IPhoneLinkTestPanelProps {
  phoneNumber: string;
}

export const PhoneLinkTestPanel: FC<IPhoneLinkTestPanelProps> = ({
  phoneNumber,
}) => {
  return (
    <PhoneLinkTestWrapper>
      <h3>test translated link</h3>
      <Trans
        i18nKey="landing.verifyCode.errorWhileRequestOTPClal"
        values={{ phoneNumber: phoneNumber }}
        components={{
          phone: (
            <a
              className="purple-link"
              href={`tel:${phoneNumber}`}
              aria-label={phoneNumber}
            />
          ),
        }}
      />
    </PhoneLinkTestWrapper>
  );
};
